webpackJsonp([125591511704180],{

/***/ 419:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"excerpt":"Hello world.\n","frontmatter":{"title":"Hello World","path":"some-path","tags":["tag-1","tag-2","sample"]},"fields":{"slug":"/hello-world/"}}}]},"site":{"siteMetadata":{"title":"Chetan Arya's technology blog","facebook":{"appId":""}}}},"pathContext":{"tag":"tag-2"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-tag-2-1238a27756d99b797a3c.js